import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=27aee59a"
import script from "./OrderCard.vue?vue&type=script&lang=ts"
export * from "./OrderCard.vue?vue&type=script&lang=ts"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=27aee59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports